/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface TalentPoolProfileItem {
  id: string;
  full_name?: string | null;
  job_title?: string | null;
  company?: string | null;
  location?: string | null;
  linkedin_url?: string | null;
  linked: boolean;
  source: string;
  created_at: string;
}
